/* eslint-disable object-property-newline,sort-keys,object-property-newline */
import { ScreenTypes } from './ScreensList';

enum TagSections {
  REQUIRED = 'required',
  CUSTOMER = 'customer',
  CART = 'cart',
  TICKET = 'ticket',
  CAMPAIGN = 'campaign',
  SITE = 'site',
  PROFILE = 'profile',
  TOKEN = 'token',
}

/*
 * map is target
 * Section is used for display order in PMP
 * screens allow to filter tags to know on which screens they will be displayed in PMP
 */
export type Tag = {
  label: string,
  tag: { map: string, section?: TagSections, screens: ScreenTypes[], conditions?: Record<string, unknown>, compute?: (value: string) => string } };
export type TagBag = Array<Tag>;

const probaDisplay = (value: string): string => {
  const prob = parseFloat(value);
  const div = 1 / prob;
  const round = Math.round(1 / prob);
  const threshold = 1e-2;
  if (Math.abs(round - div) < threshold) {
    return round.toString();
  }
  return Math.ceil(1 / prob).toString();
};

export const AvailableTags: TagBag = [
  { label: 'Gain', tag: { map: 'ticket.play.disp', section: TagSections.TICKET, screens: [ScreenTypes.WON] } },
  { label: 'reward', tag: { map: 'ticket.reward', section: TagSections.TICKET, screens: [ScreenTypes.HOME] } },
  { label: 'Legal Url', tag: { map: 'campaign.legal', section: TagSections.CAMPAIGN, screens: [ScreenTypes.HOME] } },
  { label: 'Game Count', tag: { map: 'gameCount', section: TagSections.SITE, screens: [ScreenTypes.MULTIGAME] } },
  { label: 'Dotation Code', tag: { map: 'ticket.play.code', section: TagSections.TICKET, screens: [ScreenTypes.WON], conditions: {
    'campaign.dotations.win.activ': true,
    'campaign.instant.activ': true,
  } } },
  { label: 'Dotation Code', tag: { map: 'ticket.play.code', section: TagSections.TICKET, screens: [ScreenTypes.LOST], conditions: {
    'campaign.dotations.lose.activ': true,
  } } },
  { label: 'Main Proba Fraction', tag: { map: 'ticket.games.0.1', section: TagSections.TICKET, screens: [ScreenTypes.HOME], compute: probaDisplay } },
];
